import React from 'react';
import ServiceSection from '../components/Sections/Service';

function ServicesPage() {
    return (
        <div>
            {/* Page Title */}
            <section className="page-title">
                <div className="container">
                    <div className="row">
                        <div className="col col-xs-12">
                            <h2>Services</h2>
                            <p>Gregor then turned to look out the window at the weather</p>
                        </div>
                    </div>
                </div>
            </section>
            
            {/* ServiceSection con section-padding */}
            <ServiceSection className="section-padding" />
        </div>
    );
}

export default ServicesPage;